// extracted by mini-css-extract-plugin
export var headingC = "Cards4IconBg-module--headingC--1eaf7";
export var imageC = "Cards4IconBg-module--imageC--23bc4";
export var itemC = "Cards4IconBg-module--itemC--9eb87";
export var sectionWrapper = "Cards4IconBg-module--sectionWrapper--16853";
export var wrapperC = "Cards4IconBg-module--wrapperC--886fa";